/**
 * CompaniesService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class CompaniesService {
    getAllCompanies = () => {
        return apiClient.get("/getAllCompanies");
    }

    getAllCategories = (type) => {
        return apiClient.post("/getAllCategories", {table: type});
    }

    getProfileDataByCompanyAndTableName = (company, exchange) => {
        return apiClient.post("/companies/profile", {company, exchange});
    }
}
